export default {
  //constants.js --> offices
  offices: "Γραφεία",
  liaison_office: "Γραφείο Διασύνδεσης",
  internship_office: "Γραφείο Πρακτικής",
  alumni_office: "Γραφείο Αποφοίτων",
  erasmus_office: "Γραφείο Erasmus",
  physical_education_office: "Γραφείο Φυσικής Αγωγής",
  environmental_management_office: "Γραφείο Περιβαλλοντικής Διαχείρισης ΠαΜακ",
  //constants.js --> Student Teams
  student_clubs: "Σύλλογοι",
  uom_students_club: "Σύλλογος Φοιτητών ΠΑΜΑΚ",
  erasmus_student_club: "Σύλλογος Φοιτητών Erasmus",
  cybersecurity_student_club: "Λέσχη Κυβερνοασφάλειας Πανεπιστημίου Μακεδονίας",
  open_source_club: "Λέσχη Ανοιχτού Λογισμικού",
  //constants.js --> Other Services
  ethics_research_committee:
    "Επιτροπή Ηθικής και Δεοντολογίας της Έρευνας(Ε.Η.Δ.Ε.) του Πανεπιστημίου Μακεδονίας",
  student_advocate: "Συνήγορος του Φοιτητή",
  gender_eq_committee: "Επιτροπή Ισότητας Φύλων",
  student_consulting_support_center:
    "Κέντρο Συμβουλευτικής και Στήριξης Φοιτητών",
  accessibility_unit: "Μονάδα Προσβασιμότητας ΠΑΜΑΚ",
  theater_workshop: "",
  uni_publications: "Εκδόσεις Πανεπιστημίου Μακεδονίας",
};
